/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface PersonStatusDTO
 */
export interface PersonStatusDTO  {
    /**
     * 
     * @type {number}
     * @memberof PersonStatusDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PersonStatusDTO
     */
    affiliation?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonStatusDTO
     */
    status?: string;
}

/**
 * Check if a given object implements the PersonStatusDTO interface.
 */
export function instanceOfPersonStatusDTO(value: object): value is PersonStatusDTO {
    return true;
}

export function PersonStatusDTOFromJSON(json: any): PersonStatusDTO {
    return PersonStatusDTOFromJSONTyped(json, false);
}

export function PersonStatusDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonStatusDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'affiliation': json['affiliation'] == null ? undefined : json['affiliation'],
                  'status': json['status'] == null ? undefined : json['status'],
    };
}

export function PersonStatusDTOToJSON(json: any): PersonStatusDTO {
    return PersonStatusDTOToJSONTyped(json, false);
}

export function PersonStatusDTOToJSONTyped(value?: PersonStatusDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'affiliation': value['affiliation'],
        'status': value['status'],
    };
}


